import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { keyframes } from "@emotion/react";

export default function HeaderMenu({
  categories,
  subcategories,
  images,
  currentIndex,
  darkMode,
  handleLinkClick,
}) {
  const navigate = useNavigate();

  const scrollAnimation = keyframes`
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-100%);
    }
  `;

  const [currentImage, setCurrentImage] = React.useState(images[currentIndex]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => {
        const nextIndex = (images.indexOf(prevImage) + 1) % images.length;
        return images[nextIndex];
      });
    }, 4000); // Adjust the interval duration as needed

    return () => clearInterval(interval);
  }, [images]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "80px",
        right: "15px",
        zIndex: 10,
        background: darkMode ? "#333" : "#fff",
        backdropFilter: "blur(20px)",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        padding: "20px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "auto",
        minWidth: "50vw",
        minHeight: "250px",
        transition: "opacity 1.5s ease-in-out",
        opacity: 1,
        overflow: "hidden",
      }}
    >
      <Grid container spacing={2}>
        <Grid item md={8}>
          <Grid container spacing={2}>
            {categories.map((category, index) => (
              <Grid item md={4} key={index}>
                <Box>
                  <Typography
                    variant="h6"
                    color="primary"
                    onClick={() => handleLinkClick(category, null)}
                    sx={{
                      fontWeight: "bold",
                      marginBottom: "5px",
                      cursor: "pointer",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    {category.Category_Name}
                  </Typography>
                  {subcategories
                    .filter((sub) => sub.Category_Id === category.Category_Id)
                    .map((subcategory, idx) => (
                      <MenuItem
                        key={idx}
                        onClick={() => handleLinkClick(category, subcategory)}
                        sx={{
                          fontSize: "14px",
                          padding: "8px 10px",
                          transition: "background-color 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode ? "#444" : "#f1f1f1",
                          },
                        }}
                      >
                        {subcategory.Sub_Category_Name}
                      </MenuItem>
                    ))}
                </Box>
                <Divider />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item md={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {images && images.length > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "200px",
                  animation: `${scrollAnimation} ${
                    images.length * 4
                  }s linear infinite`,
                }}
              >
                {images.map((image, index) => (
                  <Box
                    key={index}
                    component="img"
                    src={image}
                    alt={`Slide ${index + 1}`}
                    sx={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      marginBottom: "10px",
                    }}
                  />
                ))}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
